import AddApiKeyDialog from "@/components/PageHeader/actions/dialogs/integrations/AddApiKeyDialog/AddApiKeyDialog";
import AddConveyIntegration from "@/components/PageHeader/actions/dialogs/integrations/AddConveyIntegration/AddConveyIntegration";
import AddIntegrationDialog from "@/components/PageHeader/actions/dialogs/integrations/AddIntegrationDialog/AddIntegrationDialog";
import AddVDOIntegration from "@/components/PageHeader/actions/dialogs/integrations/AddVDOIntegration/AddVdoIntegration";
import GeneratedApiKeyDialog from "@/components/PageHeader/actions/dialogs/integrations/GeneratedApiKeyDialog/GeneratedApiKeyDialog";
import IntegrationTypeDialog from "@/components/PageHeader/actions/dialogs/integrations/IntegrationTypeDialog/IntegrationTypeDialog";
import EditConveyIntegrationDialog from "@/components/Table/actions/dialogs/AnalysisProviders/EditConveyIntegrationDialog/EditConveyIntegrationDialog";
import EditVdoIntegrationDialog from "@/components/Table/actions/dialogs/AnalysisProviders/EditVdoIntegrationDialog/EditVdoIntegrationDialog";
import EditIntegrationDialog from "@/components/Table/actions/dialogs/Integrations/EditIntegrationDialog/EditIntegrationDialog";
import IntegrationErrorDialog from "@/components/Table/actions/dialogs/Integrations/IntegrationErrorDialog/IntegrationErrorDialog";
import { IntegrationsErrorDialogSteps } from "@/shared";
import { useIntegrationsDialogStore } from "@/stores/useIntegrationsDialogStore";

const IntegrationsDialogHub = () => {
  const { step, errorCode, resourceData, goToEdit, closeAll } =
    useIntegrationsDialogStore();

  const renderDialog = () => {
    switch (step) {
      case IntegrationsErrorDialogSteps.TypeSelect:
        return <IntegrationTypeDialog isOpen onClose={closeAll} />;

      case IntegrationsErrorDialogSteps.Add:
        return <AddIntegrationDialog isOpen onClose={closeAll} />;

      case IntegrationsErrorDialogSteps.AddApi:
        return <AddApiKeyDialog isOpen onClose={closeAll} />;

      case IntegrationsErrorDialogSteps.ConveyIntegrations:
        return <AddConveyIntegration isOpen onClose={closeAll} />;

      case IntegrationsErrorDialogSteps.VDOIntegrations:
        return <AddVDOIntegration isOpen onClose={closeAll} />;

      case IntegrationsErrorDialogSteps.EditConvey:
        return resourceData ? (
          <EditConveyIntegrationDialog
            isOpen
            onClose={closeAll}
            rowData={resourceData}
          />
        ) : null;

      case IntegrationsErrorDialogSteps.EditVdo:
        return resourceData ? (
          <EditVdoIntegrationDialog
            isOpen
            onClose={closeAll}
            rowData={resourceData}
          />
        ) : null;

      case IntegrationsErrorDialogSteps.ApiKeyGenerated:
        return <GeneratedApiKeyDialog isOpen onClose={closeAll} />;

      case IntegrationsErrorDialogSteps.Edit:
        return resourceData ? (
          <EditIntegrationDialog
            isOpen
            onClose={closeAll}
            rowData={resourceData}
          />
        ) : null;

      default:
        return null;
    }
  };

  return (
    <>
      {renderDialog()}

      <IntegrationErrorDialog
        isOpen={step === IntegrationsErrorDialogSteps.Error}
        handleErrorClose={closeAll}
        connectionErrorCode={errorCode}
        onEditResource={goToEdit}
      />
    </>
  );
};

export default IntegrationsDialogHub;
